export const DEFAULT_DWELL_MS = 5000;
export const MIN_DWELL_SECONDS = 1;
export const MAX_DWELL_SECONDS = 60;
export const DWELL_PERSIST_DEBOUNCE_MS = 1000;

export const clampDwellSeconds = (seconds: number) => Math.min(MAX_DWELL_SECONDS, Math.max(MIN_DWELL_SECONDS, seconds));

export const dwellMsToSeconds = (dwellMs: number) =>
  clampDwellSeconds(Math.round((dwellMs || DEFAULT_DWELL_MS) / 1000));

export const dwellSecondsToMs = (seconds: number) => clampDwellSeconds(seconds) * 1000;
